<template>
  <div class="forum-view">
    <div class="forum-container">
      <div id="forum__head" class="forum__head shadow color-white" :class="{
        'forum__head--collapsed': forum__head_isCollapsed,
      }">
        <div :class="{
          'heading-one': !forum__head_isCollapsed,
          'heading-two': forum__head_isCollapsed,
        }">
          {{ topic.name }}
        </div>

        <!-- <Button v-if="isMobile" class="info-btn__button color-primary" :class="{'info-btn__button--small': forum__head_isCollapsed}" label_text="" is-cross icon="mdi-information-variant" @click.native="toggleBgInfo"/> -->
        <!-- <Button v-if="isMobile" class="info-btn__button color-primary" :class="{'info-btn__button--small': forum__head_isCollapsed}" label_text="" is-cross icon="mdi-information-outline" @click.native="toggleBgInfo" :style="{ backgroundColor: 'white'}"/> -->
        <!-- <Button v-if="isMobile" class="info-btn__button color-primary" :class="{'info-btn__button--small': forum__head_isCollapsed}" label_text="" is-cross icon="mdi-information-outline" @click.native="toggleBgInfo"/> -->
        <div class="heading__info-btn">
          <Button v-if="isMobile" elevation="1" outlined class="info-btn__button"
            :label_text="feed__info_isCollapsed ? 'Mehr Infos' : 'Zurück'" is-primary="true"
            @click.native="toggleBgInfo">

          </Button>

        </div>
      </div>

      <div class="forum__content">
        <Feed id="forum__content" ref="feed" class="content__feed" :postcards="postcards" :isEndReached="isEndReached"
          @scroll="handleScroll" />

        <div v-if="!isMobile" class="feed__info-btn">
          <Button class="info-btn__button color-primary" :icon="feed__info_isCollapsed ? 'chevronLeft' : 'chevronRight'"
            label_text="" is-cross @click.native="toggleBgInfo" />
          <Button v-if="
            loggedInUser != null &&
            loggedInUser.level_of_user !== 'normal' &&
            this.topic.topic_id !== -1
          " class="info-btn__button color-primary" :icon="feed__info_isEditable ? 'mdi-pencil-off' : 'mdi-pencil'"
            label_text="" is-cross @click.native="toggleEditTopicText" />
          <p class="info-btn__heading" :class="{ 'd-none': !feed__info_isCollapsed }">
            Hintergrundinfos
          </p>
        </div>

        <div class="feed__info color-light-grey" :class="{
          'feed__info--collapsed': feed__info_isCollapsed,
        }">
          <p class="heading-three">Hintergrundinfos:</p>

          <Button v-if="isMobile &&
            loggedInUser != null &&
            loggedInUser.level_of_user !== 'normal' &&
            this.topic.topic_id !== -1
          " class="info-btn__button color-primary" :icon="feed__info_isEditable ? 'mdi-pencil-off' : 'mdi-pencil'"
            label_text="" is-cross @click.native="toggleEditTopicText" />

          <div :is="topicInformationTransformed" :class="{ 'd-none': feed__info_isEditable }" v-bind="$props" />
          <div :class="{ 'd-none': !feed__info_isEditable }">
            <textarea v-model="topicInformationText" class="info__text--editable" />
            <v-btn elevation="1" outlined class="mb-3 approvePost"
              @click="sendUpdatedTopicInformation()">speichern</v-btn>
          </div>
        </div>

      </div>
    </div>
    <Button v-if="(!isMobile) || (isMobile && feed__info_isCollapsed)" icon="writePostcard"
      label_text="Postkarte schreiben" :is-icon="true" class="writePostcard" @click.native="
        $router.push({ name: 'createPostcard', params: { id: topic.topic_id } }), sendMatomoEvent()
        " @click="updateNav()" />
  </div>
</template>

<script>
import Feed from "@/components/Feed";
import Button from "@/components/Button";
import API from "@/services/api";
import { useIsMobile } from "@/services/utils";
import { getLoggedInUser } from "@/services/loggedIn";
import { toBoolean } from "../../../client-hubbel/src/services/utils";

export default {
  name: "ForumView",
  components: {
    Button,
    Feed,
  },
  setup() {
    const isMobile = useIsMobile();
    return { isMobile };
  },
  data: () => ({
    topic: {},
    postcards: [],
    topicInformationText: "",
    forum__head_isCollapsed: false,
    feed__info_isCollapsed: false,
    feed__info_isEditable: false,
    isEndReached: true,
    scrollTimeout: null,
  }),
  computed: {
    topicInformationTransformed() {
      // The topic information comes from a mysql database but contains vue-specific tags like <router-link>
      // To display those tags correctly, they have to be transformed by being rendered in an inner template
      return {
        template: this.topic.information,
        props: this.$options.props,
      };
    },
    loggedInUser() {
      return JSON.parse(getLoggedInUser());
    }
  },

  beforeMount() {
    (async () => {
      if (this.$route.params.topic) {
        await API.getTopicByName(this.$route.params.topic).then((res) => {
          this.topic = res.data[0];
          this.topicInformationText = this.topic.information;
        });
        this.getInitialPosts();
        document.title = this.topic.name;
      } else if (this.$route.params.post_id) {
        let post = (await API.getPostById(this.$route.params.post_id)).data;
        this.postcards.push(this.renderPost(post));
        this.topic = {
          name: "Einzelne Postkarte",
          topic_id: -1,
        };
        this.topic.information = "<div>Hier wird nur eine einzelne Postkarte angezeigt.</div>";
      } else {
        this.topic = {
          name: "Alle Postkarten",
          topic_id: -1,
        };
        this.getInitialPosts();
        this.topic.information =
          "<div><div>Hier werden Dir alle Postkarten im hubbel unabhängig von ihrem Thema nach Datum sortiert angezeigt. Die oberste Postkarte ist also immer die neuste. Du kannst auf jeder Postkarte rechts unten sehen welchem Thema sie ansonsten zugeordnet ist.<br><br>Zuletzt geändert: 02.08.2022<br>Themenpat*in: hubbel Redaktion<br><br><br><br><br><br></div></div>";
        document.title = this.topic.name;
      }
    })();
  },

  mounted() {
    document.getElementById("forum__content").addEventListener("scroll", this.handleScroll);
    this.feed__info_isCollapsed = window.innerWidth <= 960; // collapse on mobile
  },

  beforeDestroy() {
    document.getElementById("forum__content").removeEventListener("scroll", this.handleScroll);
    //TODO: https://stackoverflow.com/questions/68588188/can-not-get-element-by-getelementbyid-in-beforedestroy-lifecycle-vue
  },
  methods: {
    sendMatomoEvent() {
      if (!toBoolean(process.env.VUE_APP_USE_MATOMO)) return;
      window._paq.push([
        "trackEvent",
        "CreatePostcard on hubbel",
        "Click 'Write Postcard' Button",
        "'Write Postcard' clicked.",
      ]);
    },
    loggedIn() {
      return getLoggedInUser() !== null;
    },
    updateNav() {
      this.$emit("update_Nav");
    },
    //Debouncing fixed the scroll bug (bug that stopped loading post cards)
    handleScroll(){
      if (this.scrollTimeout){
        clearTimeout(this.scrollTimeout);
      }
      this.scrollTimeout = setTimeout(this.handleScrollDebounced, 100);
    },
    handleScrollDebounced() {
      //handle topbar collapse
      const forum__head = document.getElementById("forum__head");
      let forum__content = document.getElementById("forum__content");
      if (this.postcards.length > 1) {
        // kann man bestimmt schöner Lösen, weiß aber gerade nicht wie
        if (forum__content.scrollTop > 100) this.forum__head_isCollapsed = true;
        else if (forum__head.style.height !== "200px") this.forum__head_isCollapsed = false;
      }
      //load more posts
      if (!this.$route.params.post_id) {
        if (
          forum__content.scrollTop + forum__content.clientHeight >=
          forum__content.scrollHeight * 0.75
        ) {
          API.getNextPostsforTopic(
            this.topic.topic_id,
            3,
            this.postcards.length,
            this.postcards[0].id
          ).then((res) => {

            //console.log("NextPostsforTopic, res data: ", res.data)
            res.data.forEach((postObj) => this.postcards.push(this.renderPost(postObj)));
            this.isEndReached = res.data.length <= 0;
          });
        }
      }
    },

    toggleBgInfo() {
      this.feed__info_isCollapsed = !this.feed__info_isCollapsed;
    },
    toggleEditTopicText() {
      this.feed__info_isEditable = !this.feed__info_isEditable;
      if (!this.feed__info_isEditable) {
        this.topic.information = this.topicInformationText;
      }
    },
    renderAnswers(children, allTopicNames) {
      let answers = [];
      for (let index in children) {
        //console.log(children[index])
        children[index].allTopicNames = allTopicNames;
        const answerPost = this.renderPost(children[index]);
        answerPost.isAnswer = true;
        answers.push(answerPost);
      }
      answers = answers.filter((e) => (e.approved && !e.hidden) || (!e.approved && !e.hidden))

      answers.sort((a,b) => {
        if(a.isPinned && !b.isPinned) return -1;
        if(!a.isPinned && b.isPinned) return 1;
        return new Date(b.date) - new Date(a.date);
      });
      return answers;
    },
    renderPost(postObj) {
      //console.log('renderPost aufgerufen mit:', postObj);

      if (this.postcards.some((e) => e.id === postObj.post_id)) {
        return;
      }

      function getSender() {
        if (postObj.sender_name) {
          return postObj.sender_name;
        } else if (postObj.user.team && postObj.user.team.length > 0) {
          return postObj.user.team;
        } else if (postObj.user.last_name.length <= 0) {
          return postObj.user.first_name;
        } else {
          return postObj.user.first_name + " " + Array.from(postObj.user.last_name)[0] + ".";
        }
        //TODO maybe keep full name here for moderators
      }


      return {
        id: postObj.post_id,
        answers: this.renderAnswers(postObj.children, postObj.allTopicNames),
        isAnswer : false,
        readOnly: true,
        approved: postObj.approved,
        hidden: postObj.hidden,
        category: postObj.category,
        sender_verified: postObj.user.verified,
        sender_team: postObj.user.team,
        sender: getSender(),
        sender_name_mailbox: postObj.sender_name,
        subject: postObj.topic.name,
        allTopicNames: postObj.allTopicNames,
        text: postObj.text,
        eventTitle: postObj.eventTitle,
        eventLocation: postObj.eventLocation,
        eventStartDateTime: postObj.eventStartDateTime,
        eventEndDateTime: postObj.eventEndDateTime,
        date: postObj.createdAt.split("T")[0] + " " + postObj.createdAt.split(/[T.]/)[1],
        attachments: postObj.Attachments,
        isSaved: postObj.isSaved,
        isPinned: postObj.isPinned,
        sentFrom: postObj.sentFrom,
        //likes: postObj.postLikes.length !== 0 ? postObj.postLikes[0].likes : 0,
        likes: postObj.likes,
        isLiked: postObj.isLiked,
        show: false,
      };
    },
    getInitialPosts() {
      API.getNextPostsforTopic(this.topic.topic_id, 15, 0, -1).then((res) => {
        //console.log('Backend Rohdaten:', res.data);  // ← HIER einfügen
        res.data.forEach((postObj) => {
          //console.log('Einzelne Postkarte:', postObj);  // ← Und hier
          this.postcards.push(this.renderPost(postObj))
        });
      });
    },


    sendUpdatedTopicInformation() {
      API.updateTopicInformation(this.topic.topic_id, this.topicInformationText).then((res) => {
        console.log(res.data?.message);
        this.toggleEditTopicText();
      });
    },
  },
};
</script>
